import { cn } from "@/lib/utils";

interface SwissLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const SwissLogo = ({ className, size = "md" }: SwissLogoProps) => {
  const sizeClasses = {
    sm: "w-5 h-5",
    md: "w-[22px] h-[22px]",
    lg: "w-8 h-8"
  };

  return (
    <div className={cn("relative", sizeClasses[size], className)}>
      <svg 
        className="absolute w-full h-full" 
        viewBox="0 0 22 22" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M11.7334 0.00012207L11.7334 9.91679L21.65 9.91679C21.65 4.45012 17.1999 0.00012207 11.7334 0.00012207Z" 
          fill="currentColor" 
          className="text-brand-primary"
        />
        <path 
          d="M0 0.349976L0 9.91664L9.91667 9.91664C9.91667 4.44998 5.46667 0.349976 0 0.349976Z" 
          fill="currentColor" 
          className="text-brand-accent"
        />
        <path 
          d="M0 12.0833L0 21.65C5.46667 21.65 9.91667 17.2 9.91667 12.0833L0 12.0833Z" 
          fill="currentColor" 
          className="text-brand-primary"
        />
        <path 
          d="M11.7334 12.0833L11.7334 21.65C17.2 21.65 21.65 17.2 21.65 12.0833L11.7334 12.0833Z" 
          fill="currentColor" 
          className="text-brand-accent"
        />
      </svg>
    </div>
  );
};